import { API_BASE_URL, API_CDN_URL } from "configs/AppConfig";

export const api_base_url = API_BASE_URL + "/api";
export const api_cdn_url = API_CDN_URL + "/api";

export const API_URL = {
  login: api_base_url + "/login",
  profile: api_base_url + "/profile",
  changeProfile: api_base_url + "/update-profile",
  changePassword: api_base_url + "/update-password",

  dashboard: api_base_url + "/dashboard",

  medsos: api_base_url + "/media-sosial",
  colabMedsos: api_base_url + "/kolaborasi-medsos",
  blast: api_base_url + "/blast",
  proaksi: api_base_url + "/proaksi",
  topProaksi: api_base_url + "/top-proaksi",
  rank: api_base_url + "/rank",

  // Master Data
  satker: api_base_url + "/satker",
  tier: api_base_url + "/tier",

  // Settings
  user: api_base_url + "/manajemen-user",

  export: api_base_url + "/export",
  select: api_base_url + "/select",

  // Uploader

  upload: api_cdn_url + "/upload",
};
